import { render } from "./ContractModelShow.vue?vue&type=template&id=0bf227a8&scoped=true"
import script from "./ContractModelShow.vue?vue&type=script&lang=js"
export * from "./ContractModelShow.vue?vue&type=script&lang=js"

import "./ContractModelShow.vue?vue&type=style&index=0&id=0bf227a8&scoped=true&lang=css"
import "./ContractModelShow.vue?vue&type=style&index=1&id=0bf227a8&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf227a8"]])

export default __exports__